import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useBuildingPermit from './useBuildingPermit'
import BuildingPermitFields from './BuildingPermitFields'

const BuildingPermit = () => {
  const { t, errors, isEditable, buildingPermitOption, buildingPermitOptions, hidden, updateAddress } =
    useBuildingPermit()

  if (hidden) return null

  return (
    <>
      <SDFormControl hidden={!buildingPermitOptions.length} error={getError('building_permit_option', errors)}>
        {/* @ts-ignore */}
        <SDSelect
          disabled={isEditable === false}
          optionsList={buildingPermitOptions}
          placeholder={t('common:choose')}
          selectedValue={buildingPermitOption}
          onChangeHandler={(params: { value: Array<{ id: string }> }) => {
            updateAddress({
              building_permit_option: params.value[0]?.id || '',
              building_permit_number: '',
              building_permit_date: '',
              building_permit_entity: '',
              building_permit_city: '',
            })
          }}
          label={t('subscriptionForm:address_module.building_permit_fields.option')}
          newTranslations
          translationsPath='subscriptionForm:address_module.building_permit_types.'
        />
      </SDFormControl>

      <BuildingPermitFields />
    </>
  )
}

export default BuildingPermit
